import axiosInstance from '../api/axiosInstance';

const ENDPOINTS = {
  GET_ALL_GROUPS: '/GetPopups',
  CREATE_GROUP: '/CreatePopup',
  DELETE_GROUP: '/PopupDelete',
  UPDATE_GROUP: '/UpdatePopup'
};

export const getAllPopups = async () => {
  try {
    const response = await axiosInstance.get(ENDPOINTS.GET_ALL_GROUPS);
    if (response.data && response.data.status === 200) {
      const users = response.data.data;
      if (Array.isArray(users)) {
        return users;
      }
    }
    return [];
  } catch (error) {
    console.error('Failed to fetch users:', error);
    throw error;
  }
};

export const CreatePopup = async (userData,video,image) => {
  try {
    const formData = new FormData();
    formData.append('Baslik', userData.baslik);
    formData.append('Icerik', userData.icerik);
    formData.append('BaslangicTarihi', userData.baslangicTarihi);
    formData.append('BitisTarihi', userData.bitisTarihi);
    if (userData.foto) formData.append("Foto", userData.foto); 
    if (userData.video) formData.append("Video", userData.video); 
 
    const response = await axiosInstance.post(ENDPOINTS.CREATE_GROUP, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });

    if (response.data && response.data.status === 200) {
      return response.data;
    }
    throw new Error(response.data.message || 'Failed to create user');
  } catch (error) {
    console.error('Create user error:', error);
    throw error;
  }
};

export const deletePopup = async (userId) => {
  try {
    const response = await axiosInstance.delete(`${ENDPOINTS.DELETE_GROUP}/${userId}`);
    if (response.data && response.data.status === 200) {
      return 1;
    }
    return 0;
  } catch (error) {
    return 0;
  }
};
export const updatePopup = async (id, form) => { 
  try {
    const formData = new FormData();
    formData.append('Baslik', form.baslik);
    formData.append('Icerik', form.icerik);
    formData.append('BaslangicTarihi', form.baslangicTarihi);
    formData.append('BitisTarihi', form.bitisTarihi);
    if (form.foto) formData.append("foto", form.foto); 
    if (form.video) formData.append("video", form.video); 

    const response = await axiosInstance.put(`${ENDPOINTS.UPDATE_GROUP}/${id}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      }});
    

    if (response.data && response.data.status === 200) {
      return response.data;
    }
    throw new Error(response.data.message || 'Failed to update user');
  } catch (error) {
    console.error('Update user error:', error);
    throw error;
  }
};